import styled from '@emotion/styled';

const DisabledMaskContainer = styled.fieldset`
  opacity: 0.2;
  pointer-events: none;
`;

export { DisabledMaskContainer };
